import { Box, Flex } from '@chakra-ui/react';
import { L3_PATHS } from 'Deer/constants/routes';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  AUTO_UPDATE_STATUSES,
  REVIEW_FORM_STAGE,
  setReviewCreationKey,
  useReviewCreationV1Data,
} from 'reducers/reviewCreationV1Slice';

import { Button } from 'uiToolkitV1/Button';
import { TextLabel } from 'uiToolkitV1/Typography';

export const ReviewProcessV2Footer = () => {
  const { isLaunchConfirmationChecked, reviewStage, autoUpdateStatus } = useReviewCreationV1Data();
  const isDraft = reviewStage === REVIEW_FORM_STAGE.DRAFT;
  const disableLaunch = !isLaunchConfirmationChecked;
  const history = useHistory();
  const dispatch = useDispatch();

  const handleCancelCloseClick = () => {
    history.push(`${L3_PATHS.company.review.settings}?activeTabId=review_cycles`);
  };

  const autoUpdateText =
    // eslint-disable-next-line no-nested-ternary
    autoUpdateStatus === AUTO_UPDATE_STATUSES.UPDATED
      ? 'Auto-saved'
      : autoUpdateStatus === AUTO_UPDATE_STATUSES.IS_ERROR
        ? 'Error saving'
        : 'Saving...';

  const handleLaunchClick = () => {
    dispatch(setReviewCreationKey({ isConfirmationModalOpen: true }));
  };

  return (
    <Flex
      py={3}
      px={4}
      justifyContent="space-between"
      alignItems="center"
      bg="surface.F5F7F9"
      borderTop="1px solid"
      borderColor="border.CFD7DF"
      borderBottomRadius="8px"
    >
      <Box>
        {isDraft && (
          <Button variant="outlined" onClick={handleCancelCloseClick}>
            Cancel
          </Button>
        )}
      </Box>

      {isDraft && (
        <Flex alignItems="center" gap={3}>
          <TextLabel bold p={3}>
            {autoUpdateText}
          </TextLabel>
          <Button disabled={disableLaunch} onClick={handleLaunchClick}>
            Launch
          </Button>
        </Flex>
      )}

      {!isDraft && <Button onClick={handleCancelCloseClick}>Close</Button>}
    </Flex>
  );
};
